export const breakpoints = {
  xxs: '320px',
  xs: '480px',
  sm: '768px',
  md: '992px',
  lg: '1420px',
  xg: '1600px',
  xxg: '2000px',
};
